import { ComponentType, FC, PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

import { ButtonClose } from '@/components/buttons';
import { GeneralModalProps, Modal } from '@/components/Modal';
import { Skeleton } from '@/components/modals/ModalSkeleton';
import { useCommonStore } from '@/store';

import { ScStaticModal } from './styled';
import { ScModalContentProps } from '@/components/Modal/styled';

export interface StaticModalProps
  extends PropsWithChildren,
    GeneralModalProps,
    ScModalContentProps {
  onClose: () => void;
  title?: string;
  pending?: boolean;
  maxWidth?: number;
  hideCloseBtn?: boolean;
  icon?: ComponentType;
  bgTransparent?: boolean;
}

export const StaticModal: FC<StaticModalProps> = ({
  children,
  title,
  onClose,
  pending,
  maxWidth,
  hideCloseBtn,
  icon: Icon,
  bgTransparent,
  ...props
}) => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const { images } = useTheme();

  return (
    <Modal {...props}>
      {pending ? (
        <Skeleton />
      ) : (
        <ScStaticModal maxWidth={maxWidth} bgTransparent={bgTransparent}>
          {title && (
            <h1>
              {Icon ? <Icon /> : <images.termsAndConditionsIcon.component />}
              {title}
            </h1>
          )}
          {!hideCloseBtn && (
            <ButtonClose
              gray={!isMobileDevice}
              top={isMobileDevice ? 16 : 12}
              right={isMobileDevice ? 16 : 12}
              onClick={onClose}
            />
          )}
          {children}
        </ScStaticModal>
      )}
    </Modal>
  );
};
